import React, { useState, createContext, useContext } from "react";

interface AuthZeroDataType {
  isToUseAuthZero: boolean;
  authZeroAccessToken: string | undefined;
}

export interface AuthZeroContextPropTypes {
  data: AuthZeroDataType;
  setIsToUseAuthZero: React.Dispatch<React.SetStateAction<boolean>>;
  setAuthZeroAccessToken: React.Dispatch<React.SetStateAction<string>>;
}

type AuthZeroProviderProps = { children: React.ReactNode };

const AuthZeroContext = createContext<AuthZeroContextPropTypes | undefined>(
  undefined
);

function AuthZeroContextProvider({ children }: AuthZeroProviderProps) {
  const [isToUseAuthZero, setIsToUseAuthZero] = useState<boolean>(false);
  const [authZeroAccessToken, setAuthZeroAccessToken] = useState<
    string | undefined
  >(undefined);

  return (
    <AuthZeroContext.Provider
      value={{
        data: {
          isToUseAuthZero,
          authZeroAccessToken,
        },
        setIsToUseAuthZero,
        setAuthZeroAccessToken,
      }}
    >
      {children}
    </AuthZeroContext.Provider>
  );
}

function useAuthZeroContext() {
  const context = useContext(AuthZeroContext);
  return context;
}

export { AuthZeroContextProvider, useAuthZeroContext };
